import { history } from 'legacy/lut/helpers/route'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { getUrlWithParams } from 'core-components/helpers/url'
import { setPublishingMode } from 'core/store/appSlice'

import { selectJBPSettings } from '../../jbpSettings'
import { CHANGE_FINANCIAL_YEAR } from '../constants'

export const changeFinancialYear = createAsyncThunk<number, number>(
  CHANGE_FINANCIAL_YEAR,
  (fYear, { getState, dispatch }) => {
    history.push(getUrlWithParams({ fyear: fYear }))

    const { currentFYear } = compose(selectJBPSettings, getState)()
    const canBeEdited = fYear >= currentFYear

    if (!canBeEdited) {
      dispatch(setPublishingMode(false))
    }

    return fYear
  }
)
